import { useEffect, useRef, useState } from "react";

/** iter470 35.2 — liste des éléments manquants : une ligne par élément (« Section · Libellé »), point jaune si obligatoire, gris si facultatif.
 *  `items` = [{ key, label, required, testId, block }] ; `onPick(item)` ouvre l'étape / la section et met le champ en évidence.
 *  Clic sur l'enfant : ouvre / ferme la liste (si items vides, le clic suit l'enfant). `hover` : la même liste en infobulle au survol. */
export default function MissingPopover({ items = [], onPick, children, hover = false, align = "left", testId = "missing-popover" }) {
  const [open, setOpen] = useState(false);
  const [hov, setHov] = useState(false);
  const ref = useRef(null);
  const listRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  const n = items.length;
  const shown = n > 0 && (open || (hover && hov));
  return (
    <span ref={ref} className="relative inline-flex" onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      onClickCapture={(e) => { if (!n || listRef.current?.contains(e.target)) return; e.stopPropagation(); e.preventDefault(); setOpen((o) => !o); }} data-testid={testId} data-count={n} data-open={shown}>
      {children}
      {shown && (
        <div ref={listRef} className="absolute" role="list" style={{ top: "calc(100% + 6px)", [align === "right" ? "right" : "left"]: 0, zIndex: 50, minWidth: 220, maxWidth: 340, padding: 6, background: "#1C1C21", border: "1px solid #33333B", borderRadius: 10, boxShadow: "0 12px 32px rgba(0,0,0,.45)" }} onClick={(e) => e.stopPropagation()} data-testid={`${testId}-list`}>
          {items.map((it) => (
            <button key={it.key} type="button" role="listitem" onClick={(e) => { e.stopPropagation(); setOpen(false); setHov(false); onPick?.(it); }} className="flex items-center w-full text-left hover:bg-white/5" style={{ gap: 8, padding: "5px 8px", borderRadius: 7, fontSize: 11.5, color: "#E8E8EA" }} title={it.label} data-testid={`${testId}-item-${it.key}`} data-required={!!it.required}>
              <span className="shrink-0" style={{ width: 7, height: 7, borderRadius: "50%", background: it.required ? "#EAB308" : "#6A6A72" }} />
              <span className="truncate">{it.label}</span>
            </button>))}
        </div>)}
    </span>
  );
}
